<template>
  <div class="d-flex flex-column">
    <div class="d-flex justify-content-end">
      <h4>
        <b-badge
          v-if="providerOption.deliveryTime"
          v-b-popover.hover.bottom="
            `${$t('deliveryTime')}: ${providerOption.deliveryTime}`
          "
          variant="primary"
        >
          {{ providerOption.name }}
        </b-badge>
      </h4>
    </div>
    <div class="d-flex justify-content-center">
      <span class="h3 font-weight-bolder mr-1  ">{{ $t('total') }}: </span><span
        :class="backgroundGreen ? 'text-white' : 'text-success'"
        class="h3 font-weight-bolder"
      >${{ providerOption.total | money }}
      </span>
    </div>
    <div
      :class="backgroundGreen ? 'text-light' : ''"
      class="d-flex flex-column text-center"
    >
      <div class="d-flex flex-column mb-1">
        <span class="font-weight-bold">{{ $t('unitPrice') }} </span>
        <span
          class="font-weight-bold"
        >S/IVA ${{ providerOption.unit_price_with_commission | money }}
        </span>
      </div>
      <span class="font-weight-bold">
        {{
          $tc(unitsFilter(providerOption.unit_type), providerOption.quantity)
        }}
      </span>
      <div>
        <b-badge
          v-if="selectedBranch"
          variant="warning"
          class="font-weight-bold"
        >
          {{ selectedBranch }}
        </b-badge>
      </div>
      <div class="text-center mt-1">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    providerOption: {
      type: Object,
      default() {
        return {
          name: 'Proveedor 1',
          deliveryTime: '48 Hrs',
          quantity: '50',
          unit_price: '105',
        }
      },
    },
    backgroundGreen: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  computed: {
    ...mapGetters('app', ['unitsFilter']),
    selectedBranch() {
      if (this.providerOption.selected_supplier_branch) {
        return this.providerOption.selected_supplier_branch.name
      }
      return false
    },
  },

  mounted() {},
}
</script>

<style lang="scss" scoped>
.bg-green {
  background-color: #77c77b;
}
.bg-yellow {
  background-color: #ffe600;
}
</style>
